import { useEffect, useState } from "react"
import { Section } from "../../../shared/components/Section/Section"
import { useTranslation } from "react-i18next"
import { CustomButton } from "../../../shared/components/CustomButton/CustomButton"
import HowIsWasDoneModal from "../../../shared/components/HowIsWasDoneModal/HowIsWasDoneModal"

export default function MetodologySection() {
    const [isHowIsWasDoneOpen, setIsHowIsWasDoneOpen] = useState(false)

    const { t }: any = useTranslation()
    const [isMobile, setIsMobile] = useState(
        window.matchMedia('(max-width: 768px)').matches
    )
    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 768px)')
        const handleChange = (e: any) => setIsMobile(e.matches)

        mediaQuery.addEventListener('change', handleChange)
        return () => mediaQuery.removeEventListener('change', handleChange)
    }, [])

    return (
        <>
            <Section
                borderBottom={false}
                headerConfig={{
                    title: t('investigation.title'),
                    description: t('investigation.description'),
                    inLine: !isMobile,
                    maxWidth: '100%',
                }}
            >
                <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '20px' }}>
                    <CustomButton
                        to=""
                        icon="go"
                        customAction={() => {
                            setIsHowIsWasDoneOpen(true)
                        }}
                    >
                        {t('investigation.readMore')}
                    </CustomButton>
                </div>
            </Section>
            {
                isHowIsWasDoneOpen && (
                    <HowIsWasDoneModal
                        open={isHowIsWasDoneOpen}
                        onClose={() => setIsHowIsWasDoneOpen(false)}
                    />
                )
            }
        </>
    )
}